import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import { Tag } from '../models/tag.model';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ApiService {
    constructor(
        private http: Http
    ) {}

    private dataURL = './data/Stamps-JSON-Export-v3.json';  // URL to JSON file

    data: any;
   

    getData(): Promise<any> {
        if(!this.data){
            this.data = this.http.get(this.dataURL)
                .toPromise()
                .then(res => res.json())
                .catch(this.handleError)
        }

        return this.data;
    }
    
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/services/api.service.ts